export const PARTNER_CONSTS = {
    GET_PARTNERS: "GET_PARTNERS",
    GET_PARTNER_BY_ID: "GET_PARTNER_BY_ID",
    DELETE_PARTNER_BY_ID: "DELETE_PARTNER_BY_ID",

    GET_PARTNER_CATEGORIES: "GET_PARTNER_CATEGORIES",
    GET_PARTNER_CATEGORY_BY_ID: "GET_PARTNER_CATEGORY_BY_ID",
    DELETE_PARTNER_CATEGORY_BY_ID: "DELETE_PARTNER_CATEGORY_BY_ID",

    GET_PARTNER_OFFERS: "GET_PARTNER_OFFERS",
    GET_PARTNER_OFFER_BY_ID: "GET_PARTNER_OFFER_BY_ID",
    DELETE_PARTNER_OFFER_BY_ID: "DELETE_PARTNER_OFFER_BY_ID",

};
